// src/components/Footer.js
import React from 'react';
//import { FaWhatsapp, FaInstagram, FaTripadvisor, FaAirbnb } from 'react-icons/fa';
//import { MdTour } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaInstagram, FaTripadvisor } from 'react-icons/fa';
import { FaAirbnb } from 'react-icons/fa6';        // Airbnb is in fa6
import { MdTour, MdExplore } from 'react-icons/md'; // MdExplore for Viator

const Footer = () => {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@600;700&family=Jost:wght@300;400;500;600&display=swap');

        :root {
          --gold: #C9A84C;
          --gold-light: #E8C97A;
        }

        .footer-root {
          font-family: 'Jost', sans-serif;
          background: #0A0A0A;
          border-top: 1px solid rgba(201,168,76,0.25);
          color: rgba(255,255,255,0.7);
        }

        /* Top gold bar */
        .footer-topbar {
          height: 3px;
          background: linear-gradient(90deg, transparent, var(--gold), transparent);
        }

        /* Tours strip */
        .footer-tours {
          border-bottom: 1px solid rgba(255,255,255,0.07);
          padding: 2.2rem 1.5rem;
          text-align: center;
        }
        .footer-tours-label {
          font-size: 0.62rem;
          letter-spacing: 4px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 1rem;
        }
        .footer-tours .tour-pill {
          display: inline-block;
          border: 1px solid rgba(201,168,76,0.35);
          color: rgba(255,255,255,0.75);
          padding: 0.4rem 1.2rem;
          border-radius: 50px;
          font-size: 0.78rem;
          font-weight: 500;
          text-decoration: none;
          transition: border-color 0.25s, color 0.25s, background 0.25s;
          margin: 0.25rem;
        }
        .footer-tours .tour-pill:hover {
          border-color: var(--gold);
          color: var(--gold);
          background: rgba(201,168,76,0.06);
        }

        /* Main grid */
        .footer-main {
          padding: 3.5rem 1.5rem 2.5rem;
        }
        .footer-brand-name {
          font-family: 'Cormorant Garamond', serif;
          font-size: 1.5rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 0.3rem;
          line-height: 1.15;
        }
        .footer-brand-sub {
          font-size: 0.65rem;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 0.9rem;
        }
        .footer-brand-desc {
          font-size: 0.85rem;
          font-weight: 300;
          line-height: 1.75;
          color: rgba(255,255,255,0.5);
          max-width: 260px;
        }

        .footer-col-title {
          font-size: 0.65rem;
          letter-spacing: 3px;
          text-transform: uppercase;
          color: var(--gold);
          margin-bottom: 1.2rem;
          font-weight: 600;
        }
        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .footer-links li { margin-bottom: 0.65rem; }
        .footer-links a {
          color: rgba(255,255,255,0.55);
          text-decoration: none;
          font-size: 0.85rem;
          font-weight: 400;
          transition: color 0.2s;
        }
        .footer-links a:hover { color: var(--gold); }

        .footer-contact-item {
          display: flex;
          gap: 0.6rem;
          align-items: flex-start;
          margin-bottom: 0.75rem;
        }
        .footer-contact-icon {
          color: var(--gold);
          font-size: 0.9rem;
          margin-top: 2px;
          flex-shrink: 0;
        }
        .footer-contact-text {
          font-size: 0.83rem;
          color: rgba(255,255,255,0.55);
          line-height: 1.5;
        }
        .footer-contact-text a {
          color: rgba(255,255,255,0.55);
          text-decoration: none;
          transition: color 0.2s;
        }
        .footer-contact-text a:hover { color: var(--gold); }

        /* Social buttons */
        .footer-social-row {
          display: flex;
          flex-wrap: wrap;
          gap: 0.6rem;
          justify-content: center;
          padding: 2rem 1.5rem;
          border-top: 1px solid rgba(255,255,255,0.07);
        }
        .social-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.45rem;
          padding: 0.55rem 1.2rem;
          border-radius: 50px;
          font-size: 0.78rem;
          font-weight: 500;
          font-family: 'Jost', sans-serif;
          text-decoration: none;
          border: 1px solid transparent;
          transition: transform 0.2s, opacity 0.2s;
        }
        .social-btn:hover { transform: translateY(-2px); opacity: 0.9; }
        .social-btn.whatsapp { background: #25D366; color: #fff; }
        .social-btn.instagram {
          background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
          color: #fff;
        }
        .social-btn.getyourguide { background: #FF5533; color: #fff; }
        .social-btn.tripadvisor { background: #34E0A1; color: #000; }
        .social-btn.viator { background: #1aff35; color: #fff; }
        .social-btn.airbnb { background: #FF385C; color: #fff; }

        /* Bottom bar */
        .footer-bottom {
          border-top: 1px solid rgba(255,255,255,0.07);
          padding: 1.5rem 1.5rem;
          text-align: center;
        }
        .footer-legal-links {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 0.4rem 1.5rem;
          margin-bottom: 0.8rem;
        }
        .footer-legal-links a {
          font-size: 0.75rem;
          color: rgba(255,255,255,0.35);
          text-decoration: none;
          letter-spacing: 0.5px;
          transition: color 0.2s;
        }
        .footer-legal-links a:hover { color: var(--gold); }
        .footer-copy {
          font-size: 0.75rem;
          color: rgba(255,255,255,0.25);
          margin: 0;
          letter-spacing: 0.5px;
        }
        .footer-copy span { color: var(--gold); }
      `}</style>

      <footer className="footer-root">
        <div className="footer-topbar" />

        {/* Available Tours */}
        <div className="footer-tours">
          <p className="footer-tours-label">Our Tours</p>
          <div>
            {[
              { to: "/city-walk", label: "Downtown City Walk" },
              { to: "/historical-cultural", label: "Historical & Cultural" },
              { to: "/excursions", label: "Excursions" },
              { to: "/slum-tours", label: "Slum Tours" },
            ].map(({ to, label }) => (
              <Link key={to} to={to} className="tour-pill">{label}</Link>
            ))}
          </div>
        </div>

        {/* Main Grid */}
        <div className="footer-main">
          <div className="container">
            <div className="row gy-4">

              {/* Brand */}
              <div className="col-12 col-md-4">
                <div className="footer-brand-name">Nairobi's Ultimate</div>
                <div className="footer-brand-sub">City Tours & Adventure</div>
                <p className="footer-brand-desc">
                  Crafting elite, immersive journeys that showcase Nairobi beyond
                  the ordinary — where culture, energy, and adventure meet.
                </p>
              </div>

              {/* Quick Links */}
              <div className="col-6 col-md-2 offset-md-1">
                <p className="footer-col-title">Navigate</p>
                <ul className="footer-links">
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/contact">Contact</Link></li>
                  <li><Link to="/terms-of-service">Terms of Service</Link></li>
                  <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="col-6 col-md-4 offset-md-1">
                <p className="footer-col-title">Get in Touch</p>
                <div className="footer-contact-item">
                  <span className="footer-contact-icon">✉</span>
                  <span className="footer-contact-text">
                    <a href="mailto:nairobisultimateexperience@gmail.com">
                      nairobisultimateexperience@gmail.com
                    </a>
                  </span>
                </div>
                <div className="footer-contact-item">
                  <span className="footer-contact-icon">✆</span>
                  <span className="footer-contact-text">
                    <a href="tel:+254105057005">+254 105 057 005</a>
                  </span>
                </div>
                <div className="footer-contact-item">
                  <span className="footer-contact-icon">⌖</span>
                  <span className="footer-contact-text">Nairobi, Kenya</span>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Social Buttons */}
        <div className="footer-social-row">
          <a href="https://wa.me/254105057005" target="_blank" rel="noopener noreferrer" className="social-btn whatsapp">
            <FaWhatsapp /> WhatsApp
          </a>
          <a href="https://www.instagram.com/nairobisultimate_citytours?igsh=MXd4aXJicXJ3aWZubg==" target="_blank" rel="noopener noreferrer" className="social-btn instagram">
            <FaInstagram /> Instagram
          </a>
            <a href="https://www.getyourguide.com/-s468221" target="_blank" rel="noopener noreferrer" className="social-btn getyourguide">
            <MdTour /> GetYourGuide
          </a>
          <a href="https://www.viator.com/tours/Nairobi/NairobisUltimateExperience-Downtown-walking-tour/d5280-5557336P1" target="_blank" rel="noopener noreferrer" className="social-btn viator">
            <MdExplore /> Viator
          </a>
          <a href="https://www.airbnb.com/experiences/6378551?viralityEntryPoint=2&s=76" target="_blank" rel="noopener noreferrer" className="social-btn airbnb">
            <FaAirbnb /> Airbnb
          </a>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <div className="footer-legal-links">
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <a href="mailto:nairobisultimateexperience@gmail.com">Contact</a>
          </div>
          <p className="footer-copy">
            &copy; {new Date().getFullYear()} <span>Nairobi's Ultimate Experience</span>. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default Footer;
